import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function OptionCard({
  label,
  selected,
  onSelect,
  compact,
}: {
  label: string;
  selected: boolean;
  onSelect: () => void;
  compact?: boolean;
}) {
  return (
    <motion.button
      type="button"
      onClick={onSelect}
      whileHover={{ scale: 1.015 }}
      whileTap={{ scale: 0.985 }}
      transition={{ type: "spring", stiffness: 400, damping: 26 }}
      className={cn(
        "group relative flex w-full items-center justify-between gap-3 rounded-xl border border-border bg-card/40 text-left backdrop-blur-md transition-colors",
        compact ? "px-4 py-3 text-sm" : "px-5 py-4 text-sm sm:text-base",
        selected
          ? "border-primary/60 bg-primary/10 text-foreground glow-primary"
          : "hover:border-primary/30 hover:bg-card/70",
      )}
    >
      <span className="font-medium leading-snug tracking-wide">{label}</span>
      <i
        className={cn(
          "fi fi-tr-check-circle shrink-0 text-lg leading-none transition-colors",
          selected ? "text-primary" : "text-muted-foreground/40",
        )}
      />
    </motion.button>
  );
}
